import React, { useState } from "react";
import RtaPasswordsModal from "./RtaPasswordsModal";
import { Layout, Menu, Button, Drawer, Grid, Tooltip } from "antd";
import { useNavigate, Outlet } from "react-router-dom";
import {
  LockOutlined,
  KeyOutlined,
  TeamOutlined,
  TableOutlined,
  PieChartOutlined,
  SlidersOutlined,
  UserAddOutlined,
  LogoutOutlined,
  MenuOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  FilePdfOutlined, // ✅ ADDED
  FileTextOutlined,
} from "@ant-design/icons";

/*import {
  LockOutlined,
  KeyOutlined,
  TeamOutlined,
  TableOutlined,
  PieChartOutlined,
  SlidersOutlined,
  UserAddOutlined,
  LogoutOutlined,
  MenuOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
*/
const { Sider, Content } = Layout;
const { useBreakpoint } = Grid;

// Helper: Title Case
const toTitleCase = (str = "") => {
  return String(str)
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const getIsAdminFromStorage = () => {
  const raw =
    localStorage.getItem("is_admin") ??
    localStorage.getItem("isadmin") ??
    localStorage.getItem("admin") ??
    localStorage.getItem("isAdmin");
  if (raw == null) return false;
  const val = String(raw).trim().toLowerCase();
  return val === "true" || val === "1" || val === "yes" || val === "y";
};

function AppLayout() {
  const navigate = useNavigate();
  const screens = useBreakpoint();
  const isDesktop = screens.lg;

  const arnHolderName = toTitleCase(localStorage.getItem("arn_holder_name") || "");
  const isAdmin = getIsAdminFromStorage();

  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [rtaOpen, setRtaOpen] = useState(false);

  // ---- MENU ITEMS ----
  /*const baseItems = [
    {
      key: "dashboard",
      icon: <DashboardOutlined />,
      label: "Dashboard",
      onClick: () => navigate("/dashboard"),
    },
    {
      key: "ledger",
      icon: <TableOutlined />,
      label: "View Ledger",
      children: [
        {
          key: "ledger-individual",
          label: "View Individual Ledgers",
          onClick: () => navigate("/ledger"),
        },
        {
          key: "ledger-family",
          label: "View Family Group Ledgers",
          onClick: () => navigate("/family_ledger"),
        },
      ],
    },
    {
      key: "family-group",
      icon: <TeamOutlined />,
      label: "Manage Family Group",
      onClick: () => navigate("/managefamilygroup"),
    },
    {
      key: "change-arn-password",
      icon: <LockOutlined />,
      label: "Change Login Password",
      onClick: () => navigate("/change-arn-password"),
    },
  ];
*/
const baseItems = [
  {
    key: "dashboard",
    icon: <DashboardOutlined />,
    label: "Dashboard",
    onClick: () => navigate("/dashboard"),
  },
  {
    key: "ledger",
    icon: <TableOutlined />,
    label: "View Ledger",
    children: [
      {
        key: "ledger-individual",
        label: "View Individual Ledgers",
        onClick: () => navigate("/ledger"),
      },
      {
        key: "ledger-family",
        label: "View Family Group Ledgers",
        onClick: () => navigate("/family_ledger"),
      },
     {
      key: "ledger-amc-scheme",
      label: "View AMC & Scheme Wise Reports",
      onClick: () => navigate("/amc-scheme-report"),
    },
    ],
  },
  {
    key: "reports",
    icon: <FileTextOutlined />,
    label: "Reports",
    children: [
      {
        key: "client-master-report",
        label: "Generate Client Master Report",
        onClick: () => navigate("/client-master-report"),
      },
      {
        key: "report-downloads",
        label: "Downloads",
        onClick: () => navigate("/report-downloads"),
      },
    ],
  },
  {
    key: "family-group",
    icon: <TeamOutlined />,
    label: "Manage Family Group",
    onClick: () => navigate("/managefamilygroup"),
  },
  {
    key: "change-arn-password",
    icon: <LockOutlined />,
    label: "Change Login Password",
    onClick: () => navigate("/change-arn-password"),
  },

  // ✅ NEW MENU OPTION (ONLY THIS IS ADDED)
  {
    key: "upload-health-policy",
    icon: <FilePdfOutlined />,
    label: "Upload Health Insurance Pdf",
    onClick: () => navigate("/upload-health-policy"),
  },
];

  if (isAdmin) {
    baseItems.push(
      {
        key: "scheme-type-mapping",
        icon: <SlidersOutlined />,
        label: "Scheme Type Mapping",
        onClick: () => navigate("/schemetypemapping"),
      },
      {
        key: "distributor-onboarding",
        icon: <UserAddOutlined />,
        label: "Distributor On Boarding",
        onClick: () => navigate("/arn_creation"),
      },
      {
        key: "show-rta-passwords",
        icon: <KeyOutlined />,
        label: "Show RTA File Passwords",
        onClick: () => setRtaOpen(true),
      }
    );
  }

  const handleMenuClick = (item) => {
    item.onClick?.();
    if (!isDesktop) setDrawerOpen(false);
  };

  // ---- Sidebar Header ----
  const SidebarHeader = (
    <div
      style={{
        padding: "10px 10px",
        borderBottom: "1px solid #f0f0f0",
        display: "flex",
        alignItems: "center",
        gap: 8,
      }}
    >
      {isDesktop && (
        <Tooltip title={collapsed ? "Expand" : "Collapse"}>
          <Button
            type="text"
            size="small"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed((c) => !c)}
          />
        </Tooltip>
      )}

      <div
        style={{
          fontWeight: 700,
          fontSize: 15,
          display: "flex",
          alignItems: "center",
          gap: 8,
          flex: 1,
          whiteSpace: "normal",   // ✅ allow wrapping
          overflow: "hidden",
        }}
      >
        <PieChartOutlined /> {arnHolderName || "Distributor"}
      </div>

      <Tooltip title="Logout">
        <Button
          type="text"
          icon={<LogoutOutlined />}
          danger
          onClick={() => {
            localStorage.clear();
            window.location.href = "/login";
          }}
        />
      </Tooltip>
    </div>
  );

  // ---- Sidebar Menu ----
  const SidebarMenu = (
    <Menu
      mode="inline"
      selectable={false}
      items={baseItems.map((item) => ({
        ...item,
        onClick: () => handleMenuClick(item),
        children: item.children
          ? item.children.map((child) => ({
              ...child,
              onClick: () => handleMenuClick(child),
            }))
          : undefined,
      }))}
    />
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {!isDesktop && (
        <Button
          type="primary"
          shape="circle"
          size="large"
          icon={<MenuOutlined />}
          onClick={() => setDrawerOpen(true)}
          style={{
            position: "fixed",
            top: 12,
            left: 12,
            zIndex: 1000,
          }}
          aria-label="Open menu"
        />
      )}

      <Layout>
        {isDesktop && (
          <Sider
            collapsible
            collapsed={collapsed}
            onCollapse={setCollapsed}
            width={240}
            theme="dark"
            style={{ background: "#0f3d8a", boxShadow: "4px 0 20px rgba(15,61,138,.12)" }}
          >
            {SidebarHeader}
            {SidebarMenu}
          </Sider>
        )}

        {!isDesktop && (
          <Drawer
            title={
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <PieChartOutlined /> <span>{arnHolderName || "Distributor"}</span>
              </div>
            }
            placement="left"
            onClose={() => setDrawerOpen(false)}
            open={drawerOpen}
            bodyStyle={{ padding: 0 }}
            extra={
              <Tooltip title="Logout">
                <Button
                  type="text"
                  icon={<LogoutOutlined />}
                  danger
                  onClick={() => {
                    localStorage.clear();
                    window.location.href = "/login";
                  }}
                />
              </Tooltip>
            }
          >
            {SidebarMenu}
          </Drawer>
        )}

        <Content style={{ background: "#fff", minHeight: "100vh" }}>
          <Outlet />
        </Content>
      </Layout>
      <RtaPasswordsModal open={rtaOpen} onClose={() => setRtaOpen(false)} />
    </Layout>
  );
}

export default AppLayout;
